export default __webpack_public_path__ + "static/media/providencebp-logo.5c58b4ec.PNG";